import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import color from "../../Constants/colors";
import { WorkspaceQuestionList } from "../../Models/workspace";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface WorkspaceQuestionListsTableProps {
  data: WorkspaceQuestionList[];
}

const WorkspaceQuestionListsTable: React.FC<
  WorkspaceQuestionListsTableProps
> = ({ data }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("workspaces");

  if (!data || data.length === 0) {
    return (
      <Typography
        sx={{
          fontSize: "0.85rem",
          fontWeight: 500,
          color: color.primary_dark,
          paddingLeft: 2,
        }}
      >
        {t("noQuestionLists")}
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <TableContainer
        sx={{
          border: `1px solid ${color.gray300}`,
          borderRadius: 2,
          backgroundColor: color.gray50,
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: color.primary_dark,
                  fontWeight: "bolder",
                  width: "30%",
                }}
              >
                {t("table_name")}
              </TableCell>
              <TableCell
                sx={{
                  color: color.primary_dark,
                  fontWeight: "bolder",
                  width: "25%",
                }}
              >
                {t("table_certificationCategory")}
              </TableCell>
              <TableCell
                sx={{
                  color: color.primary_dark,
                  fontWeight: "bolder",
                  width: "30%",
                }}
              >
                {t("table_createdBy")}
              </TableCell>
              <TableCell
                sx={{
                  color: color.primary_dark,
                  fontWeight: "bolder",
                  width: "15%",
                }}
              >
                {t("table_default")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((list) => (
              <TableRow
                key={list.id}
                sx={{
                  "&:hover": { backgroundColor: color.gray100 },
                }}
              >
                <TableCell
                  sx={{
                    color: color.primary_dark,
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(`/question_list/${list.id}`)}
                >
                  {list.name}
                </TableCell>
                <TableCell sx={{ color: color.primary_dark }}>
                  {list.certification_category?.name ||
                    t("table_notApplicable")}
                </TableCell>
                <TableCell sx={{ color: color.primary_dark }}>
                  {`${list.created_by?.name || ""} ${
                    list.created_by?.surname || ""
                  } ${
                    list.created_by?.email ? `(${list.created_by?.email})` : ""
                  }`.trim() || t("table_system")}
                </TableCell>
                <TableCell sx={{ color: color.primary_dark }}>
                  {list.default ? t("table_yes") : t("table_no")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WorkspaceQuestionListsTable;
